import React from 'react';
import { GhostIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { DigitalMicrocopy } from '../DigitalMicrocopy';
import { finalSummary } from '../../data/salesContent';
import { CHECKOUT_URL, PRICE, PRODUCT_IMAGE, PRODUCT_IMAGE_ALT } from '../../data/product';
export function FinalCtaSection() {
  return <section id="final" className="bg-night pb-6 pt-8 sm:pt-12" aria-labelledby="final-title" data-id="element-27" data-mp="2dhs65camnkpv">
      <div className="mx-auto max-w-6xl px-5 text-center sm:px-8" data-id="element-28" data-mp="2rhtflg4yk0gy">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime" data-id="element-29" data-mp="2mkkzrm7a88iv">Halloween PE Ready™</p>
        <h2 id="final-title" className="mx-auto mt-4 max-w-4xl font-display text-[40px] font-extrabold leading-[1] tracking-tight text-cream sm:text-7xl" data-id="element-30" data-mp="319h6nfxlrfhw">
          Your Halloween PE Week Is <span className="text-pumpkin" data-id="element-31" data-mp="3aannjq45ysbo">Already Planned.</span>
        </h2>
        <img src={PRODUCT_IMAGE} alt={PRODUCT_IMAGE_ALT} className="mx-auto mt-6 h-auto w-full max-w-3xl" width={1254} height={1254} loading="lazy" decoding="async" data-id="element-32" data-mp="368afuw5uwkc9" />

        <ul className="mx-auto mt-6 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-33" data-mp="262odojztsn9a">
          {finalSummary.map(item => <li key={item} className="rounded-full border border-line bg-navy px-4 py-2 text-sm font-semibold text-cream" data-id="element-34" data-mp="2b3lwmysntlbu">
              {item}
            </li>)}
        </ul>

        <p className="mt-5 text-sm font-bold uppercase tracking-[0.18em] text-muted" data-id="element-35" data-mp="2p0ikcrdhemoi">Only</p>
        <p className="font-display text-7xl font-extrabold leading-none text-cream" data-id="element-36" data-mp="2ts0n9kz2exc4">
          {PRICE}
          <span className="ml-2 text-xl font-bold text-muted" data-id="element-37" data-mp="2yrd7rz2grsbj">USD</span>
        </p>

        <div className="mx-auto mt-5 flex max-w-xl flex-col items-center gap-4" data-id="element-38" data-mp="33pwx89g9nm8n">
          <CtaButton href={CHECKOUT_URL} data-id="element-39" data-mp="33nty8zx4yirs">Get Instant Access to Halloween PE Ready™</CtaButton>
          <DigitalMicrocopy items={['One-Time Payment', '100% Digital', 'Instant Access']} align="center" data-id="element-40" data-mp="38mx24h1dqiy6" />
        </div>

        <p className="mt-6 font-display text-2xl font-extrabold leading-snug text-cream sm:text-3xl" data-id="element-41" data-mp="2e1svzaysddqy">
          Open it. Set up the gym. <span className="text-pumpkin" data-id="element-42" data-mp="2sqxbgke753vd">Start teaching.</span>
        </p>
      </div>

      <footer className="mx-auto mt-6 max-w-7xl border-t border-line px-5 pt-5 sm:px-8" data-id="element-43" data-mp="2nzfc20rtnbci">
        <div className="flex flex-col items-center justify-between gap-3 text-center sm:flex-row sm:text-left" data-id="element-44" data-mp="31r3ltxellnqb">
          <p className="flex items-center gap-2 font-display text-sm font-extrabold text-cream" data-id="element-45" data-mp="2wssdjr3ybla7">
            <GhostIcon className="h-4 w-4 text-pumpkin" aria-hidden="true" data-id="element-46" data-mp="3bq2wtmmu5vgh" />
            HALLOWEEN PE READY™ <span className="font-semibold text-muted" data-id="element-47" data-mp="36px2tzt3fwv8">— Less planning. More movement.</span>
          </p>
          <p className="text-xs text-muted" data-id="element-48" data-mp="1haqkga81gmc3">Digital product · Downloadable PDFs · No physical items are shipped.</p>
        </div>
      </footer>
    </section>;
}